import MenuItem from './MenuItem';
import store from '../../../store/index';

class MenuService {
  /**
   * @type MenuItem[]
   */
  menuItems = [];

  addItem(menuItem) {
    if (!(menuItem instanceof MenuItem)) {
      throw new Error('addMenuItem accepts MenuItem class instance only');
    }
    store.dispatch('app/addMenuItem', {
      name: menuItem.name,
      menuItem,
    });
  }

  removeItem(name) {
    store.dispatch('app/removeMenuItem', name);
  }

  getItems() {
    return store.getters['app/menuItems'];
  }

  getItem(name) {
    const items = this.getItems();
    return items.find(item => item.name === name);
  }
}


export default new MenuService();
